import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressBar"];

  connect() {
    this.updateProgressBar = this.updateProgressBar.bind(this);
    document.addEventListener('scroll', this.updateProgressBar);
  }

  disconnect() {
    document.removeEventListener('scroll', this.updateProgressBar);
  }

  updateProgressBar() {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
    const scrollPercentage = (scrollTop / scrollHeight) * 100;
    this.progressBarTarget.style.width = `${scrollPercentage}%`;
  }
}